export default __webpack_public_path__ + "static/media/logo-sci-long.bd81209b.svg";